export class localDataStorageProvider
{
	'use strict';
	
	storageKey;
	defaultData = {};
	data;
	
	constructor(name, default_data){
		this.storageKey = name;
		this.defaultData = default_data;
		this.readData();
	}
	
	getEmptyDataSet(){
		return this.defaultData;
	}
	
	readData(){
		let d = localStorage.getItem(this.storageKey);
		if(d){
			this.data = angular.merge({}, this.getEmptyDataSet(), angular.fromJson(d));
		}
		else{
			this.data = this.getEmptyDataSet();
		}
	}
	
	getData(){
		return this.data;
	}
	
	storeData(){
		localStorage.setItem(this.storageKey, angular.toJson(this.data));
	}
	
	setData(newdata){
		this.data = newdata;
		this.storeData();
	}
	
}